import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ProductListing } from '@df/catalog-ui/listing/product-listing';
import { RelatedProductsComponentDef } from '@df/catalog-ui/related-products/related-products.component.def';
import { IProductDataV3 } from '@df/catalog/product/product';
import { CarouselModule } from '@df/ui-carousel/carousel.module';
import { Product } from '../product.decorator';
import { ProductComponent } from '../product/product.component';
/**
 * Sample usage
 *
 * ```html
 *     <related-products class="block m-t m-b-8"
 *          [source]="model"
 *          [options]="{limit: [2,3,4,4][app.client.sizeId], engines: 'category'}">
 *              You may also like
 *     </related-products>
 * ```
 */
@Component({
    selector: 'related-products',
    templateUrl: './related-products.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['./related-products.scss'],
    standalone: true,
    imports: [CommonModule, ProductComponent, CarouselModule]
})
export class RelatedProductsComponent extends RelatedProductsComponentDef {
    getEnginesName(): string {
        return this.options.engines.toString().replace(',', '-');
    }

    get localListing(): ProductListing<Product<IProductDataV3>> {
        return this.listing as any as ProductListing<Product<IProductDataV3>>;
    }
}
